import { dataIngestion } from './commonService';
export const addVehicule = async (payload) => {
	const {
		...vehicleFields
	} = payload;

	const finalPayload = {
		action: "add",
		
		...vehicleFields
	};

	return dataIngestion(finalPayload);
};

